var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurvedArrow = function SvgCurvedArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 97,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.745 0C.026 4.221.956 8.68 1.722 13.016c2.692 15.267 9.897 28.42 19.218 40.574a101.57 101.57 0 0 0 20.031 19.781 110.592 110.592 0 0 0 23.636 13.281c4.82 1.997 9.795 3.584 14.69 5.402L70.8 94.533c8.1 2.712 16.917 2.187 26.211-1.468-5.36-6.993-14.285-8.042-20.356-13.165 1.382 5.55 7.47 6.135 11.25 10.409-2.127-.064-3.79.18-5.304-.192C44.05 80.42 18.216 56.823 5.81 18.995 3.874 13.106 3.763 6.61 2.744-.001Z",
    fill: "#000"
  })));
};
export default SvgCurvedArrow;